import React, { useEffect, useState } from "react";
import styled from "styled-components";
import logo from "../images/logo.png";

function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1200);

  function handleWindowSizeChange() {
    setIsMobile(window.innerWidth <= 1200);
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return (
    <Wrapper>
      <TopImage></TopImage>
      {isMobile ? (
        <Info>
          <InfoColumn>
            <InfoTitle4 style={{ color: "white" }}>Meet</InfoTitle4>
            <InfoTitle4 style={{ marginTop: -40, color: "white" }}>
              Your
            </InfoTitle4>
            <InfoTitle4 style={{ marginTop: -40, color: "white" }}>
              Photographer
            </InfoTitle4>
          </InfoColumn>
          <img
            alt="lex"
            src={
              "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/lex3.webp"
            }
            style={{
              width: "300px",
              position: "absolute",
              top: "-420px",
              margin: "0 auto",
              transform: " translateX(-50%)",
              left: "50%",
              border: "1px solid black",
            }}
          />
          <InfoTitle5 style={{ color: "#333" }}>
            Northern Colorado & Estes Park Photographer
          </InfoTitle5>
          <Column
            style={{
              width: "300px",
              position: "absolute",
              top: 240,
              margin: "0 auto",
              transform: " translateX(-50%)",
              left: "50%",
              textAlign: "center",
            }}
          >
            <p style={{ color: "#333", marginTop: 0 }}>
              My work is driven by a passion for storytelling through imagery,
              capturing moments that feel authentic and timeless. Whether it’s
              the intimate connection between couples, the everyday beauty of
              lifestyle moments, the serene allure of nature, or the bold
              expression of creative portraits, I strive to create photographs
              that evoke emotion and tell a unique story. Each session is
              approached with a blend of artistry and attention to detail,
              ensuring every image reflects genuine emotion and personality.
            </p>
          </Column>
        </Info>
      ) : (
        <Info>
          <Row
            style={{
              justifyContent: "space-between",
              width: "100vw",
              padding: 100,
            }}
          >
            <Column
              style={{
                width: "40vw",
                position: "absolute",
                left: 100,
                top: -350,
              }}
            >
              <img
                alt="lex"
                src={
                  "https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/lex3.webp"
                }
                style={{ border: "1px solid black" }}
              />
              <InfoTitle4>Lexi Montgomery</InfoTitle4>
            </Column>
            <Column>
              <Column style={{ width: "30vw" }}></Column>
              <Column style={{ margin: "50vh 0px 0px 100px" }}>
                <InfoTitle1 style={{ color: "white" }}>Meet </InfoTitle1>
                <InfoTitle2 style={{ color: "white" }}>Your New</InfoTitle2>
                <InfoTitle3 style={{ color: "white" }}>Photographer</InfoTitle3>
              </Column>
            </Column>
          </Row>
          <InfoTitle>
            <InfoTitle4 style={{ color: "#333" }}>
              Northern Colorado & Estes Park Photographer
            </InfoTitle4>
            <Column>
              <p style={{ color: "#333", marginTop: 0 }}>
                My work is driven by a passion for storytelling through imagery,
                capturing moments that feel authentic and timeless. Whether it’s
                the intimate connection between couples, the everyday beauty of
                lifestyle moments, the serene allure of nature, or the bold
                expression of creative portraits, I strive to create photographs
                that evoke emotion and tell a unique story. Each session is
                approached with a blend of artistry and attention to detail,
                ensuring every image reflects genuine emotion and personality.
              </p>
            </Column>
          </InfoTitle>
        </Info>
      )}

      <WhiteShort>
        <Column style={{ width: "100%", textAlign: "center" }}>
          <div
            style={{
              padding: "5px",
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              border: "1px solid #333",
              margin: "0px auto 0px auto",
            }}
          >
            <img
              alt="logo"
              src={logo}
              style={{
                borderRadius: "50%",
                margin: "0px auto 0px auto",
                width: "200px",
                border: "1px solid black",
                marginLeft: -0.5,
                marginTop: -0.5,
              }}
            />
          </div>
        </Column>
      </WhiteShort>
    </Wrapper>
  );
}
export default About;

const Hero = styled.h1`
  font-size: 2em;
  color: #000;
`;

const InfoTitle = styled.div`
  position: absolute;
  top: -20px;
  left: 60vw;
  width: 30vw;
  @media only screen and (min-width: 1200px) {
  }
`;

const InfoTitle1 = styled.p`
  font-size: 2.5em;
  position: absolute;
  top: -180px;
  left: 60vw;
`;

const InfoTitle2 = styled.p`
  font-size: 2.5em;
  position: absolute;
  top: -130px;
  left: 60vw;
  @media only screen and (min-width: 1200px) {
  }
`;

const InfoTitle3 = styled.p`
  font-size: 2.5em;
  position: absolute;
  top: -80px;
  left: 60vw;
  @media only screen and (min-width: 1200px) {
  }
`;

const InfoTitle4 = styled.p`
  font-size: 2.5em;
`;

const InfoTitle5 = styled.p`
  font-size: 2.5em;
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 80vw;
  text-align: center;
`;

const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: -600px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  width: 80vw;
`;

// Create a Wrapper component that'll render a <section> tag with some styles
const Wrapper = styled.section`
  flex-direction: column;
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  overflow-x: hidden;
`;

const TopImage = styled.section`
  position: relative;
  display: flex;
  justify-content: space-evenly;
  background-image: url(${"https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/bioBackground.webp"});
  background-size: cover; /* Adjust as needed */
  background-position: center; /* Adjust as needed */
  background-repeat: no-repeat; /* Adjust as needed */
  width: 100%; /* Example dimensions */
  height: 700px; /* Example dimensions */
  width: 100%;
  @media only screen and (min-width: 1200px) {
    height: 600px;
  }
`;

const Info = styled.section`
  flex-direction: row;
  position: relative;
  display: flex;
  background: #fcfaf2;
  align-items: center;
  height: 800px;
  width: 100%;
  @media only screen and (min-width: 1200px) {
    height: 120vh;
  }
`;

const WhiteShort = styled.section`
  flex-direction: row;
  display: flex;
  justify-content: space-evenly;
  background: #fff;
  height: fit-content;
  padding: 30px 0px 30px;
  width: 100%;
`;

const Column = styled.section`
  display: flex;
  flex-direction: column;
`;

const Row = styled.section`
  display: flex;
  flex-direction: row;
`;
